import { formatMoney } from '@kon/shared';

/** Admin always works in the base currency (USD). */
export function money(baseCents: number): string {
  return formatMoney(baseCents, 'USD');
}

export function dateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export function dateShort(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

/** Today and N days ago as YYYY-MM-DD (for the stats date-range default). */
export function isoDateNDaysAgo(days: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - days);
  return d.toISOString().slice(0, 10);
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}
